export default "__VITE_ASSET__M4uNf6UR__"